import { createServiceSchema } from "@/schemas/service";
import { formatValidationError } from "@/lib/validation-errors";
import type { ServiceModality } from "@/lib/modality";

export interface ServiceFormValues {
  name: string;
  description: string;
  /** null = polje je prazno; ne pretvara se tiho u 0. */
  durationMinutes: number | null;
  modality: ServiceModality;
  /** Usluga sa više članova; null = jedna osoba. */
  maxMembers: number | null;
}

export interface ServicePayload {
  name: string;
  description: string;
  durationMinutes: number;
  price: number;
  modality: ServiceModality;
  maxMembers: number | null;
}

/**
 * Tijelo zahtjeva za spremanje usluge iz forme, provjereno istom shemom kao na
 * serveru. Prazan opis dobija naziv usluge (isto kao onboarding), jer WP-migrirane
 * usluge imaju opis "" i inače se ne bi mogla spremiti ni sama izmjena cijene.
 */
export function buildServicePayload(
  form: ServiceFormValues,
  grossPrice: number,
): { data: ServicePayload } | { error: string } {
  const name = form.name.trim();
  const payload = {
    name,
    description: form.description.trim() || name,
    durationMinutes: form.durationMinutes,
    price: grossPrice,
    modality: form.modality,
    maxMembers: form.maxMembers,
  };
  const parsed = createServiceSchema.safeParse(payload);
  if (!parsed.success) return { error: formatValidationError(parsed.error.issues, payload).error };
  return { data: { ...payload, durationMinutes: parsed.data.durationMinutes } };
}
